<h2 class="show-for-medium">Signed Out</h2>
<hr class="divider show-for-medium">
<p>
  You have successfully signed out of the system.
</p>